import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "webcheck-body" }
const _hoisted_2 = {
  key: 0,
  class: "webcheck-form-block w-form"
}
const _hoisted_3 = {
  name: "email-form",
  "data-name": "Email Form",
  class: "webcheck-form",
  "aria-label": "Email Form"
}
const _hoisted_4 = {
  key: 0,
  class: "webcheck-small-text",
  style: {"color":"salmon"}
}
const _hoisted_5 = {
  key: 1,
  class: "webcheck-stats-wrapper"
}
const _hoisted_6 = { class: "webcheck-gauge-wrapper" }
const _hoisted_7 = { class: "webcheck-gauge-center-wrapper" }
const _hoisted_8 = { class: "webcheck-gauge-center-cirlce" }
const _hoisted_9 = { class: "webcheck-gauge-score large" }
const _hoisted_10 = { class: "webcheck-main-stats" }
const _hoisted_11 = { class: "webcheck-stat-website" }
const _hoisted_12 = { class: "webcheck-stat-text-wrapper" }
const _hoisted_13 = { class: "webcheck-stat-text" }
const _hoisted_14 = { class: "webcheck-stat-bar-wrapper" }
const _hoisted_15 = { class: "webcheck-stat-text-wrapper" }
const _hoisted_16 = { class: "webcheck-stat-text" }
const _hoisted_17 = { class: "webcheck-stat-bar-wrapper" }
const _hoisted_18 = { class: "webcheck-stat-text-wrapper" }
const _hoisted_19 = { class: "webcheck-stat-text" }
const _hoisted_20 = { class: "webcheck-stat-bar-wrapper" }
const _hoisted_21 = { class: "webcheck-stat-text-wrapper" }
const _hoisted_22 = { class: "webcheck-stat-text" }
const _hoisted_23 = { class: "webcheck-stat-bar-wrapper" }
const _hoisted_24 = { ref: "results" }
const _hoisted_25 = { class: "webcheck-stat-nav" }
const _hoisted_26 = {
  key: 0,
  class: "webcheck-stat-block-wrapper"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "webcheck-stat-block-subtitle" }
const _hoisted_29 = { class: "webcheck-stat-block-text" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 0,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_32 = {
  key: 1,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_37 = {
  key: 3,
  class: "webcheck-stat-detail-wrapper"
}
const _hoisted_38 = { class: "webcheck-detail-row" }
const _hoisted_39 = {
  key: 1,
  class: "webcheck-stat-block-wrapper"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "webcheck-stat-block-subtitle" }
const _hoisted_42 = { class: "webcheck-stat-block-text" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_45 = {
  key: 1,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_50 = {
  key: 3,
  class: "webcheck-stat-detail-wrapper"
}
const _hoisted_51 = { class: "webcheck-detail-row" }
const _hoisted_52 = {
  key: 2,
  class: "webcheck-stat-block-wrapper"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "webcheck-stat-block-subtitle" }
const _hoisted_55 = { class: "webcheck-stat-block-text" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 0,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_58 = {
  key: 1,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_63 = {
  key: 3,
  class: "webcheck-stat-detail-wrapper"
}
const _hoisted_64 = { class: "webcheck-detail-row" }
const _hoisted_65 = {
  key: 3,
  class: "webcheck-stat-block-wrapper"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "webcheck-stat-block-subtitle" }
const _hoisted_68 = { class: "webcheck-stat-block-text" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  key: 0,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_71 = {
  key: 1,
  class: "webcheck-stat-block-score-wrapper"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { class: "webcheck-stat-block-score-wrapper" }
const _hoisted_76 = {
  key: 3,
  class: "webcheck-stat-detail-wrapper"
}
const _hoisted_77 = { class: "webcheck-detail-row" }
const _hoisted_78 = {
  key: 2,
  class: "webcheck-scanning-animation-wrapper"
}
const _hoisted_79 = { class: "webcheck-scanning-text" }
const _hoisted_80 = { class: "webcheck-scanning-url" }
const _hoisted_81 = {
  key: 3,
  class: "contact-wrapper"
}
const _hoisted_82 = { class: "webcheck-contact-form-wrapper w-form" }
const _hoisted_83 = {
  key: 0,
  type: "submit",
  class: "webcheck-contact-form-btn w-button",
  value: "Submit"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 1,
  class: "webcheck-contact-done-wrapper"
}
const _hoisted_86 = { class: "webcheck-contact-form-finish-send-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _cache[40] || (_cache[40] = _createElementVNode("img", {
      src: "https://cdn.prod.website-files.com/67ae209f895ca2988224af8b/67ae25d58dc3c526a330d9b9_Logo.svg",
      loading: "lazy",
      width: "161",
      alt: "",
      class: "webcheck-logo"
    }, null, -1)),
    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "webcheck-title" }, [
      _createElementVNode("strong", { class: "bold-text" }, "Analyze Your Website"),
      _createElementVNode("br")
    ], -1)),
    (!_ctx.isLoading && !_ctx.apiResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "webcheck-input w-input",
              maxlength: "256",
              placeholder: "Enter your URL (e.g. www.example.com)",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.url) = $event))
            }, null, 512), [
              [_vModelText, _ctx.url]
            ]),
            _createElementVNode("div", {
              class: "webcheck-submit-btn w-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.analyzeUrl(_ctx.url)))
            }, "Analyze"),
            _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "webcheck-small-text" }, [
            _createElementVNode("a", {
              href: "https://policies.google.com/terms?hl=en",
              target: "_blank",
              class: "webcheck-external-link"
            }, [
              _createElementVNode("span", null, "Google")
            ]),
            _createTextVNode(" Recaptcha and PageSpeed API are used for security and performance analysis ")
          ], -1)),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Error Analyzing URL: " + _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.apiResponse && !_ctx.error && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "webcheck-gauge-outer" }, null, -1)),
            _createElementVNode("div", {
              class: "webcheck-gauge-outer-inner",
              style: _normalizeStyle({ transform: 'rotate(' + (_ctx.totalScore / 100) / 2 + 'turn)' })
            }, null, 4),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.totalScore), 1),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "webcheck-gauge-score" }, "Overall Score", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.url), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, "SEO Score " + _toDisplayString((_ctx.seoScore * 100).toFixed(0)) + "%", 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "webcheck-stat-bar-fill",
                  style: _normalizeStyle({ width: _ctx.seoScore * 100 + '%' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, "Accessibility Score " + _toDisplayString((_ctx.accessabilityScore * 100).toFixed(0)) + "%", 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "webcheck-stat-bar-fill",
                  style: _normalizeStyle({ width: _ctx.accessabilityScore * 100 + '%' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, "Performance Score " + _toDisplayString((_ctx.performanceScore * 100).toFixed(0)) + "%", 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: "webcheck-stat-bar-fill",
                  style: _normalizeStyle({ width: _ctx.performanceScore * 100 + '%' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, "Best Practices Score " + _toDisplayString((_ctx.bestPracticesScore * 100).toFixed(0)) + "%", 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "webcheck-stat-bar-fill",
                  style: _normalizeStyle({ width: _ctx.bestPracticesScore * 100 + '%' })
                }, null, 4)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, null, 512),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              class: _normalizeClass(["webcheck-stat-nav-link", { selected: _ctx.activeTab == 'seo' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'seo'))
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("span", { class: "webcheck-stat-nav-link-icon" }, "travel_explore", -1),
              _createElementVNode("span", { class: "webcheck-stat-nav-link-text" }, "SEO", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["webcheck-stat-nav-link", { selected: _ctx.activeTab == 'access' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'access'))
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("span", { class: "webcheck-stat-nav-link-icon" }, "accessibility_new", -1),
              _createElementVNode("span", { class: "webcheck-stat-nav-link-text" }, "Accessability", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["webcheck-stat-nav-link", { selected: _ctx.activeTab == 'performance' }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'performance'))
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("span", { class: "webcheck-stat-nav-link-icon" }, "manufacturing", -1),
              _createElementVNode("span", { class: "webcheck-stat-nav-link-text" }, "Performance", -1)
            ]), 2),
            _createElementVNode("div", {
              class: _normalizeClass(["webcheck-stat-nav-link", { selected: _ctx.activeTab == 'practices' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'practices'))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "webcheck-stat-nav-link-icon" }, "done_all", -1),
              _createElementVNode("span", { class: "webcheck-stat-nav-link-text" }, "Practice", -1)
            ]), 2)
          ]),
          (_ctx.activeTab === 'seo')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "webcheck-stat-block-title" }, [
                  _createTextVNode("SEO Audit"),
                  _createElementVNode("br")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seoAudits, (audit) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["webcheck-stat-block-text-wrapper", { fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }]),
                    key: audit.id
                  }, [
                    (audit.score !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(audit.title), 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(audit.description), 1),
                          (audit.scoreDisplayMode === 'binary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (audit.score === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[18] || (_cache[18] = [
                                      _createTextVNode(" Score: "),
                                      _createElementVNode("span", { class: "webcheck-stat-block-text-pass-score" }, "Pass", -1)
                                    ])))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[19] || (_cache[19] = [
                                      _createElementVNode("div", { class: "webcheck-stat-block-score-text" }, "Score:", -1),
                                      _createElementVNode("div", { class: "webcheck-stat-block-text-fail-score" }, "Fail", -1)
                                    ])))
                              ]))
                            : (audit.scoreDisplayMode === 'numeric')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% (" + _toDisplayString(audit.numericValue) + " " + _toDisplayString(audit.numericUnit) + ") ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% ", 1)
                                ])),
                          (audit.details && audit.details.items && audit.details.items.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "webcheck-stat-column-head-text",
                                      key: heading.key
                                    }, _toDisplayString(heading.label), 1))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.items, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "webcheck-detail-row",
                                    key: index
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "webcheck-stat-value",
                                        style: {"white-space":"pre-wrap","font-family":"monospace"},
                                        key: heading.key
                                      }, _toDisplayString(_ctx.showDetailText(item[heading.key])), 1))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'access')
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "webcheck-stat-block-title" }, [
                  _createTextVNode("Accessability Audit"),
                  _createElementVNode("br")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessabilityAudits, (audit) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["webcheck-stat-block-text-wrapper", { fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }]),
                    key: audit.id
                  }, [
                    (audit.score !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, _toDisplayString(audit.title), 1),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(audit.description), 1),
                          (audit.scoreDisplayMode === 'binary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (audit.score === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _cache[21] || (_cache[21] = [
                                      _createTextVNode(" Score: "),
                                      _createElementVNode("span", { class: "webcheck-stat-block-text-pass-score" }, "Pass", -1)
                                    ])))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_45, _cache[22] || (_cache[22] = [
                                      _createElementVNode("div", { class: "webcheck-stat-block-score-text" }, "Score:", -1),
                                      _createElementVNode("div", { class: "webcheck-stat-block-text-fail-score" }, "Fail", -1)
                                    ])))
                              ]))
                            : (audit.scoreDisplayMode === 'numeric')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% (" + _toDisplayString(audit.numericValue) + " " + _toDisplayString(audit.numericUnit) + ") ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% ", 1)
                                ])),
                          (audit.details && audit.details.items && audit.details.items.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "webcheck-stat-column-head-text",
                                      key: heading.key
                                    }, _toDisplayString(heading.label), 1))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.items, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "webcheck-detail-row",
                                    key: index
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "webcheck-stat-value",
                                        style: {"white-space":"pre-wrap","font-family":"monospace"},
                                        key: heading.key
                                      }, _toDisplayString(_ctx.showDetailText(item[heading.key])), 1))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'performance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "webcheck-stat-block-title" }, [
                  _createTextVNode("Performance Audit"),
                  _createElementVNode("br")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.performanceAudits, (audit) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["webcheck-stat-block-text-wrapper", { fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }]),
                    key: audit.id
                  }, [
                    (audit.score !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, _toDisplayString(audit.title), 1),
                          _createElementVNode("div", _hoisted_55, _toDisplayString(audit.description), 1),
                          (audit.scoreDisplayMode === 'binary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                (audit.score === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, _cache[24] || (_cache[24] = [
                                      _createTextVNode(" Score: "),
                                      _createElementVNode("span", { class: "webcheck-stat-block-text-pass-score" }, "Pass", -1)
                                    ])))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[25] || (_cache[25] = [
                                      _createElementVNode("div", { class: "webcheck-stat-block-score-text" }, "Score:", -1),
                                      _createElementVNode("div", { class: "webcheck-stat-block-text-fail-score" }, "Fail", -1)
                                    ])))
                              ]))
                            : (audit.scoreDisplayMode === 'numeric')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% (" + _toDisplayString(audit.numericValue) + " " + _toDisplayString(audit.numericUnit) + ") ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% ", 1)
                                ])),
                          (audit.details && audit.details.items && audit.details.items.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "webcheck-stat-column-head-text",
                                      key: heading.key
                                    }, _toDisplayString(heading.label), 1))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.items, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "webcheck-detail-row",
                                    key: index
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "webcheck-stat-value",
                                        style: {"white-space":"pre-wrap","font-family":"monospace"},
                                        key: heading.key
                                      }, _toDisplayString(_ctx.showDetailText(item[heading.key])), 1))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'practices')
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "webcheck-stat-block-title" }, [
                  _createTextVNode("Best Practices Audit"),
                  _createElementVNode("br")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestPracticesAudits, (audit) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["webcheck-stat-block-text-wrapper", { fail: audit.scoreDisplayMode === 'binary' && audit.score === 0 }]),
                    key: audit.id
                  }, [
                    (audit.score !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, _toDisplayString(audit.title), 1),
                          _createElementVNode("div", _hoisted_68, _toDisplayString(audit.description), 1),
                          (audit.scoreDisplayMode === 'binary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                (audit.score === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, _cache[27] || (_cache[27] = [
                                      _createTextVNode(" Score: "),
                                      _createElementVNode("span", { class: "webcheck-stat-block-text-pass-score" }, "Pass", -1)
                                    ])))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_71, _cache[28] || (_cache[28] = [
                                      _createElementVNode("div", { class: "webcheck-stat-block-score-text" }, "Score:", -1),
                                      _createElementVNode("div", { class: "webcheck-stat-block-text-fail-score" }, "Fail", -1)
                                    ])))
                              ]))
                            : (audit.scoreDisplayMode === 'numeric')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% (" + _toDisplayString(audit.numericValue) + " " + _toDisplayString(audit.numericUnit) + ") ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, " Score: " + _toDisplayString((audit.score * 100).toFixed(2)) + "% ", 1)
                                ])),
                          (audit.details && audit.details.items && audit.details.items.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "webcheck-stat-column-head-text",
                                      key: heading.key
                                    }, _toDisplayString(heading.label), 1))
                                  }), 128))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.items, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "webcheck-detail-row",
                                    key: index
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.details.headings, (heading) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "webcheck-stat-value",
                                        style: {"white-space":"pre-wrap","font-family":"monospace"},
                                        key: heading.key
                                      }, _toDisplayString(_ctx.showDetailText(item[heading.key])), 1))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _cache[31] || (_cache[31] = _createElementVNode("img", {
            src: "https://cdn.prod.website-files.com/67ae209f895ca2988224af8b/67eda5d3e4309699665c6227_Animation%20-%201743627601433.gif",
            loading: "lazy",
            alt: "",
            class: "webcheck-animation-gif"
          }, null, -1)),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, "Analyzing " + _toDisplayString(_ctx.url), 1),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "webcheck-small-text" }, "This might take up to two minutes", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "webcheck-contact-us-btn",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showContact = true))
    }, _cache[32] || (_cache[32] = [
      _createElementVNode("div", { class: "webcheck-contact-us-btn-text" }, "Contact Us", -1)
    ])),
    (_ctx.showContact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", {
              class: "webcheck-contact-form-close-btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showContact = false))
            }, "close"),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "webcheck-contact-form-title" }, "Contact Us", -1)),
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "webcheck-contact-form-subtitle" }, [
              _createTextVNode("Reach out to us with any questions."),
              _createElementVNode("br")
            ], -1)),
            _createElementVNode("form", {
              "aria-label": "Contact Form",
              ref: "contactForm",
              onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
            }, [
              _cache[33] || (_cache[33] = _createStaticVNode("<label for=\"name\" data-v-6765eca5>Name/Organization *</label><input class=\"webcheck-contact-input w-input\" autofocus=\"true\" maxlength=\"256\" name=\"name_input\" data-name=\"name_input\" placeholder=\"Enter your name or organization\" type=\"text\" required=\"true\" data-v-6765eca5><label for=\"email\" data-v-6765eca5>Email *</label><input class=\"webcheck-contact-input w-input\" autofocus=\"true\" maxlength=\"256\" data-name=\"email_input\" name=\"email_input\" placeholder=\"Enter your email address\" type=\"email\" id=\"email\" required=\"true\" data-v-6765eca5><label for=\"field\" data-v-6765eca5>Message</label><textarea autofocus=\"true\" placeholder=\"Type your message\" maxlength=\"5000\" data-name=\"message_input\" name=\"message_input\" class=\"webcheck-contact-input text-area w-input\" required=\"true\" data-v-6765eca5></textarea>", 6)),
              (!_ctx.formIsSending)
                ? (_openBlock(), _createElementBlock("input", _hoisted_83))
                : _createCommentVNode("", true),
              _cache[34] || (_cache[34] = _createElementVNode("div", null, null, -1))
            ], 544),
            (_ctx.formIsSending)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Sending..."))
              : _createCommentVNode("", true),
            (_ctx.formIsSent && !_ctx.formIsSending)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "webcheck-form-sent-title icon" }, "task", -1)),
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "webcheck-form-sent-title" }, "Thank you!", -1)),
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-block-2" }, "We received your message and we'll get back to you as soon as we can", -1)),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", {
                      class: "webcheck-contact-us-btn-text",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showContact = false))
                    }, "Close")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}